import { createContext, useContext } from 'react';

type Values = {
  headerHeight: number;
  safeAreaTop: number;
  safeAreaBottom: number;
  safeAreaLeft: number;
  safeAreaRight: number;
};

type Props = {
  children: React.ReactNode;
} & Values;

const SizingContext = createContext<Values>({
  headerHeight: 0,
  safeAreaTop: 0,
  safeAreaBottom: 0,
  safeAreaLeft: 0,
  safeAreaRight: 0,
});

export function SizingProvider({
  children,
  headerHeight,
  safeAreaTop,
  safeAreaBottom,
  safeAreaLeft,
  safeAreaRight,
}: Props) {
  return (
    <SizingContext.Provider
      value={{
        headerHeight,
        safeAreaTop,
        safeAreaBottom,
        safeAreaLeft,
        safeAreaRight,
      }}
    >
      {children}
    </SizingContext.Provider>
  );
}

export function useSizing() {
  return useContext(SizingContext);
}
